<template>
    <div>
        <div v-if="!addToggle" class="px-3 px-sm-5 py-4">
            <div class="text-right mt-3 mb-3">
                <button class="btn buttons-csv buttons-html5 btn-outline-primary" type="button" :title="$t('button_link.add') + $t('subMenu.salon_menu_therapy')" @click="addToggle = !addToggle">
                    <span class="fal fa-plus mr-2"></span>
                    <span>{{$t('button_link.add')}}{{$t('subMenu.salon_menu_therapy')}}</span>
                </button>
            </div>
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4 p-3">
                    <div class="ml-auto mb-3 text-right">
                        <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                            :data="exportData"
                            :fields="exportFields"
                            :header="exportHeaders"
                            type="csv"
                            :escapeCsv="false"
                            :name="exportFileName">
                            <span>CSV</span>
                        </exportCSV>
                        <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                            <span class="mr-3">PDF</span>
                            <i class="arrow-down fas fa-angle-down"></i> 
                        </button> -->
                    </div>
                </div>
                <div class="panel-container">
                    <div class="panel-content">
                        <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                            <b-spinner label="Loading..."></b-spinner>
                        </div>
                        <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">{{$t('table.no_records')}}</div>
                        <div v-if="!isSpinnerShow && totalEntries != 0" class="dataTables_wrapper dt-bootstrap4">
                            <div class="row justify-content-end mt-2">
                                <div class="col-auto pt-2">
                                    <span>{{$t('table.pagination', {'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries,})}}</span>
                                </div>
                                <div class="col-auto">
                                    <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries" @input="handlePagination" aria-controls="tblProductItems"></b-pagination>
                                </div>
                            </div>
                            <div v-if="!isSpinnerShow && totalEntries != 0" class="row">
                                <div class="col-sm-12 overflow-auto" >
                                    <b-table striped hover bordered :fields="fields" :items="treatmentItems" responsive="sm">
                                        <template #cell(index)="data">
                                            {{ data.index + startPage }}
                                        </template>
                                        <template #cell(TnTherapyName)="data">
                                            <a class="text-primary fw-500 link" @click="showEdit(data.item)">{{data.item.TnTherapyName}}</a>
                                        </template>
                                        <template #cell(TnTherapyDetails)="data">
                                            {{data.item.TnTherapyDetails == '' ? '-' : data.item.TnTherapyDetails}}
                                        </template>
                                        <template #cell(TnTherapyUnitPrice)="data">
                                            {{formatPrice(data.item.TnTherapyUnitPrice)}}
                                        </template>
                                        <template #cell(TnTreatmentActive)="data">
                                            <span class="badge" :class="data.item.TnTreatmentActive == 1 ? 'badge-primary' : 'badge-secondary'">{{data.item.TnTreatmentActive == 1 ? $t('table.value.active') : $t('table.value.inactive')}}</span>
                                        </template>
                                        <template #cell(action)="data">
                                            <a class="link text-primary" :title="$t('button_link.delete') + $t('subMenu.salon_menu_therapy')" @click="showDelete(data.item)">
                                                <i class="fal fa-trash"></i>
                                            </a>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr">
                    <h2>{{$t('button_link.add')}}{{$t('subMenu.salon_menu_therapy')}}</h2>
                </div>
                <div class="panel-container">
                    <div class="panel-content">
                        <therapyForm :isEdit="false" :treatment="optionTreatment" @returnTherapy="returnTherapy"></therapyForm>
                    </div>
                </div>
            </div>
        </div>
        <div :class="{'show': editToggleModal }" class="modal fade">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4 text-capitalize">{{$t('header.edit') + $t('subMenu.salon_menu_therapy')}}
                            <small class="m-0 text-muted">{{$t('subMenu.salon_menu_therapy')}} - "{{sTitle}}"</small>
                        </h5>
                        <button type="button" class="close" @click="editToggleModal = false">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <therapyForm ref="therapyForm" :isEdit="true" :treatment="optionTreatment" @returnTherapy="returnTherapy"></therapyForm>
                    </div>
                </div>
            </div>
        </div>
        <deleteModal ref="deleteModal" @performConfirmAction="deleteTherapy"></deleteModal>
    </div>
</template>
<script>
import moment from 'moment'
import TherapyForm from './Therapy_Form'
import DeleteModal from './../../Delete_Modal'
import {formatPrice} from './../../../../assets/js/dashboard/utilities'
import {setReturnData, handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'
export default {
    name: 'therapy',
    components:{
        TherapyForm,
        DeleteModal
    },
    data(){
        return{
            addToggle: false, editToggleModal: false,
            isSpinnerShow: false,
            sTitle: "", itemID: 0, 
            treatmentItems: [], optionTreatment: [],
            page: 0, totalEntries: 0, totalPage: 0, startPage: 1, endPage: 0, perPage: 100, currentPage: 1,
            exportHeaders: [], exportData: [], exportFileName: "", therapyExportData: []
        }   
    },
    computed:{
        fields(){
            return [
                { key: "index", label: "#", thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                { key: "TnTherapyID", label: this.$i18n.t('table.header.id', {'item': this.$i18n.t('subMenu.salon_menu_therapy')}), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                { key: "TnTherapyName", label: this.$i18n.t('table.header.title'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                { key: "TnTherapyDetails", label: this.$i18n.t('label.details'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                { key: "TnTreatmentName", label: this.$i18n.t('subMenu.salon_menu_treatment'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                { key: "TnTherapyUnitPrice", label: this.$i18n.t('label.unit_price'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                { key: "TnTreatmentActive", label: this.$i18n.t('table.header.active'), thClass: 'thead-themed align-middle text-center', tdClass: 'align-middle text-center'},
                { key: "action", label: "", thClass: 'thead-themed align-middle text-center', tdClass: 'align-middle text-center'},
            ]
        },
        exportFields(){
            var ret = {}
            ret["#"] = "index"
            ret[(this.$i18n.t('table.header.id', {'item': this.$i18n.t('subMenu.salon_menu_therapy')})).toUpperCase()] = "TnTherapyID"
            ret[(this.$i18n.t('table.header.title')).toUpperCase()] = "TnTherapyName"
            ret[(this.$i18n.t('label.details')).toUpperCase()] = "TnTherapytDetails"
            ret[(this.$i18n.t('subMenu.salon_menu_treatment')).toUpperCase()] = "TnTreatmentName"
            ret[(this.$i18n.t('label.unit_price')).toUpperCase()] = "TnTherapyUnitPrice"
            ret[(this.$i18n.t('table.header.active')).toUpperCase()] = "TnTreatmentActive"
            return ret
        },
    },
    watch:{
        "$i18n.locale"(val){
            this.setExportData(this.therapyExportData)
        }
    },
    methods:{
        formatPrice(price){
            return formatPrice(price);
        },
        closeModal(isError){
            if(!isError){
                if(this.$refs.deleteModal.toggleModal){
                    this.$refs.deleteModal.toggleModal = false
                    this.filterTherapy()
                }
            }
            
            this.$parent.$parent.isModalShow = false
        },
        filterTherapy(){
            let QUERY_STRING = ""
            this.setTherapy(QUERY_STRING)

        },
        async setTherapy(strFilter){
            this.isSpinnerShow = true
            var treatment = await this.getTreatment()
            var result = await this.getTherapy("?page=" + this.page + strFilter)
            this.totalEntries = result.count

            result.result.forEach(item=>{
                var obj = treatment.filter(obj=>obj.TnTreatmentID===item.TnTreatmentID)[0];
                item.TnTreatmentName = obj.TnTreatmentName;
            });

            if(this.optionTreatment.length == 0){
                treatment.forEach(item=>{
                    this.optionTreatment.push({
                        id: item.TnTreatmentID,
                        text: item.TnTreatmentName
                    })
                });
            }

            var retData = setReturnData(result.result, result.count, this.page)
            this.treatmentItems = retData.result;
            this.totalPage = retData.totalPage;

            this.startPage = retData.startPage;
            this.endPage = retData.endPage;
            
            this.isSpinnerShow = false
            var exp = await this.getTherapy("?" + strFilter)
            this.therapyExportData = exp.result
            this.setExportData(this.therapyExportData)
        },
        async getTreatment(){
            let $vm = this
            var result = []

            await $vm.$axios({
                method: 'get', 
                url: this.$api.MENU_TREATMENT,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.result
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result
        },
        async getTherapy(strFilter){
            let $vm = this;
            const url =  this.$api.MENU_THERAPY + strFilter;

            var result = {}

            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result
        },
        setExportData(data){
            this.exportData = []
            let header = this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_menu_therapy`)
            this.exportHeaders = [header, this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24)," "];
            this.exportFileName =  header.split(" ").join("_") +  this.$msg.REPORT.CSV

            for(var i=0; i<data.length; i++){
                this.exportData.push({
                    index: i+1,
                    TnTreatmentID: data[i].TnTreatmentID,
                    TnTreatmentName: data[i].TnTreatmentName,
                    TnTreatmentDetails: data[i].TnTreatmentDetails,
                    TnTreatmentMinPrice: data[i].TnTreatmentMinPrice,
                    TnTreatmentMaxPrice: data[i].TnTreatmentMaxPrice,
                    TnTreatmentActive: data[i].TnTreatmentActive == 1 ? this.$i18n.t('table.value.active') : this.$i18n.t('table.value.inactive'),
                })
            }
        },
        handlePagination(pg){
            if(pg != null){
                this.page = pg - 1
                this.filterTherapy();
            }
        },
        showEdit(item){
            this.sTitle = item.TnTreatmentName
            this.$refs.therapyForm.editTherapy(item)
            this.editToggleModal = true
        },
        showDelete(item){
            this.itemID = item.TnTherapyID
            var title = this.$i18n.t('button_link.delete') + this.$i18n.t('subMenu.salon_menu_therapy')
            var message = this.$i18n.t('message.confirmation.question', {'action': this.$i18n.t('message.confirmation.action.delete'), 'item': item.TnTreatmentName})
            this.$refs.deleteModal.showModal(title, message)
        },
        deleteTherapy(){
            let $vm = this
            const url =  $vm.$api.MENU_THERAPY + "/" + this.itemID + $vm.$api.DELETE;
            
            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
            })
            .then((response) => {
                if(response.status == 200){
                    var message = $vm.$i18n.t('subMenu.salon_menu_therapy') + $vm.$i18n.t('message.success.success', {'action': $vm.$i18n.t('message.success.action.delete')})
                    $vm.$parent.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        },
        returnTherapy(){
            this.filterTherapy();
            this.addToggle = this.editToggleModal = false
        },
    },
    mounted(){
        let $vm = this
        $vm.filterTherapy()
    }
}
</script>
<style scoped>
.nav-link{
    cursor: pointer;
}
.show{
    display: block;
}
.modal-lg{
    max-width: 1000px;
}
</style>